module.exports = __webpack_public_path__ + "img/prev-btn.6c9f79aa.png";